import { DateString } from "@pentacode/openapi";
import { VacationPolicy, EntityFilter } from "../../model";
import { toDateString } from "../../utils";
import { Expose } from "class-transformer";
import { safeAssign } from "./safe-assign";

export class RosterNoteDTO {
    @Expose()
    id?: number;
    @Expose()
    text: string;
    @Expose()
    start: DateString;
    @Expose()
    end: DateString;
    @Expose()
    companyId: number;
    @Expose()
    color: string | null;
    @Expose()
    filters: (EntityFilter & { type: "venue" | "department" | "position" })[];
    @Expose()
    displayAsRosterNote: boolean;
    @Expose()
    vacationPolicy: VacationPolicy;

    constructor(props: RosterNoteDTO) {
        safeAssign<RosterNoteDTO>(this, props);
    }
}

export function createRosterNote(values: Partial<RosterNoteDTO> & Pick<RosterNoteDTO, "companyId">) {
    const defaults = {
        id: undefined,
        text: "",
        start: toDateString(new Date()),
        end: toDateString(new Date()),
        color: null,
        filters: [],
        displayAsRosterNote: true,
        vacationPolicy: VacationPolicy.AllowAll,
    };

    return new RosterNoteDTO({
        ...defaults,
        ...values,
    });
}
